import moment from 'moment';

angular.module(module.exports = 'ttb.issue.workLogDetails.workLog.component', [])
    .component('workLog', {
        template: require('./work-log.component.html'),
        bindings: {
            value: '<',
            activityLogId: '=',
            teamId: '=',
            isProjectIterationBased: '<'
        },
        controller: WorkLog
    });

function WorkLog(workLogEditorService, durationService, $scope) {
    const updateView = () => {
        this.startDate = moment(this.value.startDate).local().format(ttb.constants.dateTime.DATE_TIME_FORMAT);
        this.endDate = moment(this.value.endDate).local().format(ttb.constants.dateTime.DATE_TIME_FORMAT);
    };

    this.$onInit = () => {
        this.formatter = durationService.getFormatter({ mode: 'hm' });
        if (this.value.duration) {
            this.duration = this.value.duration;
        } else {
            this.duration = {
                weeks: this.value.duration.weeks,
                days: this.value.duration.days,
                hours: this.value.duration.hours,
                minutes: this.value.duration.minutes,
            };
        }

        updateView();
        if (DEBUG) {
            console.log(this);
        }

        if(this.activityLogId && this.activityLogId!==-1 && this.activityLogId === this.value.issueActivityLogId )
        {
            this.edit();
            this.activityLogId = null;
        }
    };

    this.edit = () => {
        workLogEditorService.editActivity({ activityLogId: this.value.issueActivityLogId, teamId: this.teamId, isProjectIterationBased: this.isProjectIterationBased })
            .then(
                res => {
                   if(res)
                     {
                        this.value.startDate = res.startTime;
                        this.value.endDate = res.endTime;
                        this.value.comment = res.comment;
                        this.duration = res.duration;
                        this.value.childDuration = res.childDuration;
                        updateView();
                    }
            });
    };
    this.remove = () => {
        this.value.isDeleted = true;
        $scope.$emit('workLogChangeDeleteStatus', true);
    };
    this.undoRemove = () => {
        delete this.value.isDeleted;
        $scope.$emit('workLogChangeDeleteStatus', false);
    };
}
WorkLog.$inject = ['workLogEditorService', 'durationService','$scope'];


// WEBPACK FOOTER //
// ./components/work-log-activity/work-log.component.js